import { Locale } from 'src/modules/locale';

const socialMediaHrefs = {
  default: {
    facebook: 'https://www.facebook.com/walterknoll.official',
    instagram: 'https://www.instagram.com/walterknoll_official',
    youtube: 'https://www.youtube.com/user/walterknollonline',
    linkedin: 'https://www.linkedin.com/company/walter-knoll',
    pinterest: 'https://www.pinterest.de/walterknoll_official/_created',
  },
  us: {
    facebook: 'https://www.facebook.com/WalterKinc',
    instagram: 'https://www.instagram.com/walterk_official',
    youtube: 'https://www.youtube.com/channel/UCwy9XJ4kl0ObCplhT_2aeNQ',
  },
};

const getSocialMediaHref = (locale: Locale, site: string) => {
  return socialMediaHrefs?.[locale]?.[site] || socialMediaHrefs.default?.[site];
};

export default getSocialMediaHref;
